module.exports = __webpack_public_path__ + "assets/images_base/st-button-twitter.svg?v=e65c5ed5";